/* Stencil-Autofit — hält übersetzte Texte im Figma-Frame.
 *
 * Die Stencil-Banner sind pixelgenau auf den deutschen Text ausgelegt. Andere
 * Sprachen sind oft länger (ES/PL brauchen schnell eine Zeile mehr) und würden
 * unten aus dem Frame laufen. Dieses Skript misst den Textstapel gegen die
 * verfügbare Frame-Höhe und setzt --stx-fit (<= 1); das CSS skaliert den Stapel
 * damit als Ganzes — Schriftgrößen UND Abstände bleiben im Figma-Verhältnis.
 *
 * Läuft ohne Abhängigkeiten, reagiert auf Resize (ResizeObserver), Webfont-Load
 * und Sprachwechsel (neuer Seitenaufbau). Ohne JS bleibt --stx-fit bei 1 —
 * dann sieht es aus wie vorher, nichts ist kaputt.
 */
(function () {
  'use strict';

  var MIN_FIT = 0.62; // darunter wird es unleserlich — dann lieber Text kürzen
  var STACKS = '.hh-stx__d-stack, .hh-stx__m-stack';

  function fit(stack) {
    var frame = stack.parentElement;
    if (!frame || !frame.offsetParent) return; // unsichtbarer Breakpoint

    // Unskaliert messen
    stack.style.setProperty('--stx-fit', '1');
    var frameH = frame.clientHeight;
    var frameW = frame.clientWidth;
    if (!frameH || !frameW) return;

    var top = stack.offsetTop;
    var left = stack.offsetLeft;
    // Optional: --stx-limit (0..1) am Stapel begrenzt die nutzbare Frame-Höhe,
    // z. B. 0.5, wenn ab der halben Höhe ein randabfallendes Foto liegt, das der
    // Stapel nicht überlappen darf (Daily Moms Mobile). Ohne Angabe: ganze Höhe.
    var limit = parseFloat(window.getComputedStyle(stack).getPropertyValue('--stx-limit'));
    if (!(limit > 0 && limit <= 1)) limit = 1;
    var availH = frameH * limit - top;
    var availW = frameW - left;
    var needH = stack.scrollHeight;
    var needW = stack.scrollWidth;
    if (!needH || !needW) return;

    var scale = Math.min(1, availH / needH, availW / needW);
    if (scale >= 0.995) {
      stack.style.removeProperty('--stx-fit');
      return;
    }
    stack.style.setProperty('--stx-fit', String(Math.max(MIN_FIT, scale)));
  }

  function fitAll() {
    var stacks = document.querySelectorAll(STACKS);
    for (var i = 0; i < stacks.length; i++) fit(stacks[i]);
  }

  function init() {
    fitAll();

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { fitAll(); });
      var frames = document.querySelectorAll('.hh-stx__desktop, .hh-stx__mobile');
      for (var i = 0; i < frames.length; i++) ro.observe(frames[i]);
    } else {
      window.addEventListener('resize', fitAll, { passive: true });
    }

    // Webfonts ändern die Textmaße nachträglich
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    // Slider blendet Slides erst nach Init ein
    window.setTimeout(fitAll, 300);
    window.setTimeout(fitAll, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
